'use client';

const defaultProps = {
  variant: "primary",
  offsetTop: 0
};
export {
  defaultProps
};
